import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { get } from 'lodash'
import { Input, InputDate } from 'components/fields'
import { ElevatedButton } from 'components/layout'
import { form } from 'helpers/decorators'

import styles from './assessor-update-wwc.styl'
import updateWWCValidation from '../../../../models/assessor/updateWWCValidation'

@form({
  form: 'assessorUpdateWWC',
  disableHook: true,
  validate: updateWWCValidation
})
class AssessorUpdateWWC extends Component {
  static propTypes = {
    loading: PropTypes.bool,
    values: PropTypes.object,
    onSubmit: PropTypes.func.isRequired,
    change: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    assessorId: PropTypes.number.isRequired,
    activityId: PropTypes.number.isRequired,
    activityCategoryId: PropTypes.number.isRequired,
    assessorRegistrationId: PropTypes.number.isRequired,
    ajEventId: PropTypes.number.isRequired,
    residentialProjectId: PropTypes.number.isRequired,
    authCode: PropTypes.string,
    withWWCNumber: PropTypes.bool,
    withoutAssessor: PropTypes.bool
  }

  render() {
    const {
      handleSubmit,
      loading,
      assessorId,
      activityId,
      activityCategoryId,
      ajEventId,
      residentialProjectId,
      assessorRegistrationId,
      withWWCNumber,
      withoutAssessor
    } = this.props

    const submitData = {
      assessorId,
      activityId,
      activityCategoryId,
      ajEventId,
      residentialProjectId,
      assessorRegistrationId,
      withoutAssessor
    }

    return (
      <form
        onSubmit={handleSubmit(fields => this.props.onSubmit(fields, submitData)
        )}
      >

        <div className={`base-margin desc ${styles.bottom}`}>
          {withWWCNumber && (<>
            <div>
              <Input
                name="childProtectionNumber"
                intlKey="label.wwc_application_number"
                label="Child protection number"
              />
              <InputDate
                name="childProtectionExpirationDate"
                intlKey="label.wwc_expiration_date"
                label="Child Protection expiration date"
              />
            </div>
          </>)}
        </div>

        <ElevatedButton
          intlKey="button.update"
          isLoading={loading}
          submit
          rounded
          uppercase
          fullWidth
        >
          Update
        </ElevatedButton>
      </form>
    )
  }
}

export default AssessorUpdateWWC
